import React, { Component, Fragment, useState, useRef } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Link } from "react-router-dom";
import Axios from "axios";
import io from 'socket.io-client'

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useTranslation, I18nextProvider } from "react-i18next";
import { useSelector } from "react-redux";


import space from '../../assets/images/space-img1.png';

import RktBlue from '../../assets/images/samp.png';

import Rocketblast from '../../assets/images/animation_500_lin3iqx5-1.gif';
import saturn from '../../assets/images/saturn.png';

import racoonS from '../../assets/images/racoon_1-2.svg';

import racoonParachute from '../../assets/images/racoonParachute-1.png';

import fireImg from '../../assets/images/fire.gif';
import smookeImage from '../../assets/images/smokes.gif';








import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useEffect } from "react";

import { NumericFormat } from "react-number-format";
import useStateRef from "react-usestateref";
import { useCustomizeContext } from "../../context";
import { Notify } from "notiflix";
import { getGames } from "../../Features/GameCommon/gameCommonSlice";
import { useDispatch } from "react-redux";
import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import { betCrash, getCrashCurrentbet, getManualCashout, getAutoCashout, getlossdata, getAllCrashGameHistory, getSingleUserCrashHistory, getCrashHighRollers, Rarewinlist, getgamestatus } from "../../Features/CrashBetFunction/crashSlice";

import helper from "../../Helper";

import circle from '../../assets/images/close-circle.png';




import useNetwork from "../../components/useNetwork";



import {
    Modal,
    ModalBody
} from "reactstrap";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { SkeletonTheme } from 'react-loading-skeleton';

import { getSingleBetView } from "../../Features/GameCommon/gameCommonSlice";


const Crash = (props) => {
    const { t, i18n } = useTranslation();
    let socketURL = helper?.SocketBackendURL();

    const {
        loader: {
            loading, setLoading,
        },
        userAuthToken: {
            userToken,
        },
        bet: {
            isBet, setIsBet,
            selectedCurrency,
            balance, setBalance, balanceRef,
            selectCurrency, setSelectCurrency,
        },
        apiResponses: {
            updateRes, setUpdateRes,
        },
        modelStatus: {
            modal, setModal,
        },
        crashGameMode: {
            crashMode, setCrashMode,
        },
        crashBetContext: {
            crashBetId, setCrashBetId, crashBetIdRef,
        },
        betHistoryModal: {
            betModal, setBetModal,
        },
        sideMenu: {
            classIsActive, setClassIsActive
        },
        networkStatus: {
            isNetwork, setIsNetwork,
        },

    } = useCustomizeContext();


    //  Timer Functionality

    // stop it when needed
    const Ref = useRef(null);

    // The state for our timer
    const [timer, setTimer] = useState('00:00:00');


    const [startCount, setStartCount] = useState('');



    const historydata = useSelector((state) => state?.crashhistory?.rarewinsdata)
    const [maxBetAmount, setMaxBetAmount] = useState();
    const [maxBet, setMaxBet] = useState();
    const [minBet, setMinBet] = useState();


    const [onWinIsChecked, setOnWinIsChecked] = useState(false);
    const [onLossIsChecked, setOnLossIsChecked] = useState(false);


    const [updatebalance, setUpdatebalance] = useState();




    const [cashOutValue, setCashOutValue, cashOutRef] = useStateRef(2.00);


    const [animationTime, setAnimationDuration] = useState('');



    const [stopOnProfit, setStopOnProfit] = useState("");

    const [lossAmount, setLossAmount] = useState("");
    const [stopOnLoss, setStopOnLoss] = useState("");

    const [onWinAmount, setOnWinAmount] = useState();
    const [onLossAmount, setOnLossAmount] = useState();


    const [winPercentage, setWinPercentage] = useState("");
    const [lossPercentage, setLossPercentage] = useState("");

    const [crash_history_data, setcrash_history_data] = useState([]);


    const [rocketStatus, setRocketStatus] = useState(false);
    const [boardISActive, setBoardIsActive] = useState(false);


    let dispatch = useDispatch();

    const API_BASE = '';

    const [betemit, setBetemit] = useState(false);

    const [registerUsername, setRegisterUsername] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [loginUsername, setLoginUsername] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [betAmount, setBetAmount, betRef] = useStateRef(100.00)
    const [autoPayoutMultiplier, setAutoPayoutMultiplier] = useState(6)
    const [userData, setUserData] = useState(null);
    const [multiplier, setMultiplier] = useState(null)
    const [liveMultiplier, setLiveMultiplier] = useState('CONNECTING...')
    const [mode, setMode] = useState('manual');
    const [liveMultiplierSwitch, setLiveMultiplierSwitch] = useState(false)
    const [announcement, setAnnouncement] = useState('')
    const [globalSocket, setGlobalSocket] = useState(null)
    const [betActive, setBetActive] = useState(false)
    const [crashHistory, setCrashHistory] = useState([])
    const [roundIdList, setRoundIdList] = useState([])
    const [bBettingPhase, setbBettingPhase] = useState(false)
    const [bettingPhaseTime, setBettingPhaseTime] = useState(-1)

    const [autobet, setAutobet] = useState(false);


    const [multiplierX, setMultiplierX] = useState();


    const [startRocket, setStartRocket] = useState(false);

    const [blastRocket, setBlastRocket] = useState(false);

    const [showRocket, setShowRocket] = useState(false);

    const [isFreeze, setIsFreeze] = useState(false);




    const [existbet, setExistbet] = useState(false);
    const [existprofitstop, setExistprofitstop] = useState(false);
    const [stop_on_profit, setStop_on_profit] = useState();
    const [stop_on_loss, setStop_on_loss] = useState();






    const [bBetForNextRound, setbBetForNextRound] = useState(false)
    const [hookToNextRoundBet, setHookToNextRoundBet] = useState(false)
    const [existlossstop, setExistlossstop] = useState(false);


    const [messageToTextBox, setMessageToTextBox] = useState("")
    const [chatHistory, setChatHistory] = useState()
    const [liveBettingTable, setLiveBettingTable] = useState([])

    const [errorMessage, setErrorMessage] = useState('')
    const [authResponseMessage, setAuthResponseMessage] = useState('')
    const [globalTimeNow, setGlobalTimeNow] = useState(0)
    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [openModalRegister, setOpenModalRegister] = useState(false);
    const [chartData, setChartData] = useState({ datasets: [], });
    const [chartOptions, setChartOptions] = useState({});
    const [chartSwitch, setChartSwitch] = useState(true)
    const [gamePhaseTimeElapsed, setGamePhaseTimeElapsed] = useState()
    const [startTime, setStartTime] = useState()
    const [streakList, setStreakList] = useState([])
    const [tenNumbers, setTenNumbers] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9])

    const [no_of_bets, setNo_of_bets] = useState(0);
    const [stopbalance, setStopbalance] = useState(0);
    const [autobetamt, setAutobetamt] = useState();



    useEffect(() => {
        if (localStorage.getItem("isActive")) {
            setLiveMultiplier("Reconnecting ...");
        }
    }, []);




    const [nextBetRound, setNextBetRound] = useState(false);

    const multiplierCount = useRef([])
    const timeCount_xaxis = useRef([])
    const realCounter_yaxis = useRef(5)



    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const [activeTab1, setActiveTab1] = useState('1');
    const toggleInner = tab => {
        if (activeTab1 !== tab) setActiveTab1(tab);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        gamestatus();
    }, []);


    const [onegamehistory, setOnegamehistory] = useState([]);
    const [gamehist, setgamehist] = useState([]);
    const [crashHighRollers, setCrashHighRollers] = useState([]);

    const [betDetails, setBetDetails] = useState([]);


    //  Get Network Status


    let { effectiveType, online } = useNetwork();
    let slowConnection = ['slow-2g', '2g'];
    let speedConnection = ['3g', '4g'];

    useEffect(() => {
        let isSlowConnection = slowConnection.indexOf(effectiveType) !== -1;
        if (isSlowConnection || online === false) {
            setIsNetwork(false);
        } else {
            setIsNetwork(true);
        }
    }, [effectiveType, online])



    //   Get Single Bet  History 

    const getSingleBetDetails = async (betId, gameName) => {
        let postData = {
            "game": gameName?.toLowerCase(),
            "gameId": betId
        }
        let gameRes = await dispatch(getSingleBetView(postData));
        if (gameRes?.status) {
            setBetDetails(gameRes?.data);
            toggleBetDetails();
        }
        else {
            setBetDetails([]);
        }
    }



    const gamestatus = async () => {
        let res = await dispatch(getgamestatus())
        if (res?.status) {
            if (res?.phase === 'betting_phase') {
                setGlobalTimeNow(localStorage.getItem("globaltime") || Date.now());
                localStorage.removeItem("isActive");
                setbBettingPhase(true)
            } else if (res?.phase === 'game_phase') {
                setGlobalTimeNow(localStorage.getItem("globaltime") || Date.now());
                setLiveMultiplierSwitch(true)
                setCashOutValue(localStorage.getItem("cashout") || 2.00)
                setCrashBetId(localStorage.getItem("betid"))
                setBetActive(localStorage.getItem("betactive") || false)
                // setStartRocket(true)
            }
        }
    }



    const removeDuplicateByNext = (array) => {
        const uniqueArray = [];

        for (let i = 0; i < array?.length; i++) {
            if (array[i] !== array[i + 1]) {
                uniqueArray?.push(array[i]);
            }
        }

        return uniqueArray;
    };






    //  CRASH GAME HISTORY  


    const betCounts = [
        {
            pageLimit: "10",
            value: 10
        },
        {
            pageLimit: "20",
            value: 20
        },
        {
            pageLimit: "30",
            value: 30
        },
        {
            pageLimit: "40",
            value: 40
        },
        {
            pageLimit: "50",
            value: 50
        }
    ]


    useEffect(() => {
        gameBetHistory(betCounts[0]?.value)
    }, [userToken, updateRes]);

    const gameBetHistory = (limit) => {
        if (userToken) {
            oneGamehist(limit);
            gamehistory(limit);
            crashGameHighRollers(limit);
            raregamelist(limit)

        }
        else {
            gamehistory(limit);
            crashGameHighRollers(limit);
            raregamelist(limit)


        }
    }


    const oneGamehist = async (limit) => {
        if (mode === "manual") {
            setLoading(true);
        }
        let res = await dispatch(getSingleUserCrashHistory({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setOnegamehistory(res?.data)
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    const raregamelist = async (limit) => {
        if (mode === "manual") {
            setLoading(true);
        }
        let res = await dispatch(Rarewinlist({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    const gamehistory = async (limit) => {
        if (mode === "manual") {
            setLoading(true);
        }
        let res = await dispatch(getAllCrashGameHistory({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setgamehist(res?.data);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    const crashGameHighRollers = async (limit) => {
        if (mode === "manual") {
            setLoading(true);
        }
        let res = await dispatch(getCrashHighRollers({
            "page": 1,
            "length": limit
        }));
        if (res?.status === true) {
            setCrashHighRollers(res?.data);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    // Socket.io setup
    useEffect(() => {

        const socket = io.connect(socketURL);
        setGlobalSocket(socket)



        socket.on("start_multiplier_count", function (data) {
            setStartRocket(true);
            setRocketStatus(true);

            localStorage.setItem('isActive', true);
            localStorage.setItem("globaltime", Date.now())


            setGlobalTimeNow(Date.now())
            setLiveMultiplierSwitch(true)
        })


        socket.on("stop_multiplier_count", function (data) {
            setLiveMultiplier(data)
            setLiveMultiplierSwitch(false)
            setStartRocket(false);
            setMultiplierX(data);
            setBetActive(false)
            localStorage.removeItem("betactive");
            localStorage.removeItem("cashout");
            localStorage.removeItem("globaltime");
            localStorage.removeItem("betid");
            localStorage.removeItem("isActive");

            setIsBet(false);
            //  Blast Status
            setBlastRocket(true);
            setIsBet(false)
            socket.emit('stopvalue', { stopvalue: data });
        })

        socket.on("update_user", async function (data) {


            if (!betActive) {

                if (mode === 'auto' && autobet) {

                    if (balanceRef?.current !== 0) {


                        await betFunction()



                    }



                }
            }
        })




        socket.on("crash_history", function (data) {

            setcrash_history_data(data?.slice(-10))
        })

        socket.on("start_betting_phase", function (data) {
            localStorage.removeItem("globaltime")
            setGlobalTimeNow(Date.now())
            setLiveMultiplier("Starting...");
            setNextBetRound(true);
            setbBettingPhase(true);
            setLiveBettingTable(null)
            setHookToNextRoundBet(true);
            retrieve_active_bettors_list()

            multiplierCount.current = []
            timeCount_xaxis.current = []
        })
        socket.on("phase_start_time", function (data) {
            // setGlobalTimeNow(data)
            // localStorage.setItem("globaltime", data)

            // setcrash_history_data(data?.slice(-10))
        })

        // phase_start_time


        socket.on("bet_phase_starttime", function (data) {
            setStartCount(data);
        })



        socket.on("receive_live_betting_table", (data) => {
            setLiveBettingTable(JSON.parse(data))
            data = JSON.parse(data)

            setTenNumbers(Array((10 - data.length)).fill(2))
        })

        return () => {
            socket.disconnect();
        }
    }, [mode, autobet, betActive]);


    // useEffect(() => {
    //     if (localStorage.getItem("isActive") !== undefined && localStorage.getItem("isActive") !== "" && localStorage.getItem("isActive") !== null) {
    //         setStartRocket(true);
    //         setRocketStatus(true);
    //     }
    // }, [liveMultiplierSwitch])


    //  Blast 

    useEffect(() => {
        if (startRocket === false && blastRocket) {
            setShowRocket(true);
        }

        setTimeout(() => {
            setShowRocket(false);
        }, 3000)

    }, [blastRocket]);


    useEffect(() => {
        if (!betActive && crashBetId != "") {
            if (+cashOutValue >= +multiplierX) {
                loss_update()
                setCrashBetId("")
            }
        }
    }, [multiplierX]);

    useEffect(() => {
        if (!betActive) {



            if (autobet) {
                if (no_of_bets > 0) {
                    // betFunction();
                    // send_bet()
                    // setAutobet(false)
                }
                if (existbet) {
                    if (no_of_bets == 0) {
                        setAutobet(false)
                        setExistbet(false)
                    }
                }



                else if (stopbalance) {
                    if (existprofitstop || existlossstop) {

                        if (stop_on_profit > 0 || stop_on_loss > 0) {

                            let stopOnProfit = Number(stop_on_profit) + Number(stopbalance)

                            if (+balanceRef?.current !== 0 && stop_on_profit !== 0 && +balanceRef?.current >= stopOnProfit) {
                                setAutobet(false)
                            }

                            let stopOnLoss = Number(stopbalance) - Number(stop_on_loss)

                            if (+balanceRef?.current !== 0 && +stop_on_loss !== 0 && +balanceRef?.current <= stopOnLoss) {
                                setAutobet(false)
                            }


                        }
                    }



                }

            }
        }
    }, [no_of_bets, betActive, autobet, balance]);


    useEffect(() => {
        if (hookToNextRoundBet) {
            if (bBetForNextRound) {
                // send_bet()
                betFunction();
            }
            else {

            }
            setHookToNextRoundBet(false)
            setbBetForNextRound(false)

        }
    }, [hookToNextRoundBet])



    useEffect(() => {
        if ((betActive && (cashOutValue <= liveMultiplier))) {
            if (liveMultiplierSwitch) {
                auto_cashout_early()
                setBetActive(false)
                localStorage.setItem('betactive', false);
                localStorage.removeItem("cashout");
            }
        }
    }, [liveMultiplier])

    useEffect(() => {
        let gameCounter = null
        if (liveMultiplierSwitch) {
            setLiveMultiplier('1.00');

            gameCounter = setInterval(() => {
                let time_elapsed = (Date.now() - globalTimeNow) / 1000.0;

                setGamePhaseTimeElapsed(time_elapsed)
                setLiveMultiplier((1.0024 * Math.pow(1.0718, time_elapsed)).toFixed(2))

                if (multiplierCount.current.length < 1) {
                    multiplierCount.current = multiplierCount.current.concat([1])
                    timeCount_xaxis.current = timeCount_xaxis.current.concat([0])
                }
                if (realCounter_yaxis.current % 5 == 0) {
                    multiplierCount.current = multiplierCount.current.concat([(1.0024 * Math.pow(1.0718, time_elapsed)).toFixed(2)])
                    timeCount_xaxis.current = timeCount_xaxis.current.concat([time_elapsed])
                }
                realCounter_yaxis.current += 1
            }, 100)
        }
        return () => {
            clearInterval(gameCounter)
        }
    }, [liveMultiplierSwitch]);

    useEffect(() => {
        let bettingInterval = null

        if (bBettingPhase) {

            bettingInterval = setInterval(() => {

                let time_elapsed = ((Date.now() - globalTimeNow) / 1000.0)
                let time_remaining = (1 - time_elapsed).toFixed(2);

                setAnimationDuration((time_remaining * -60));

                setBettingPhaseTime('0.00')


                if (time_remaining < 0) {
                    setTimeout(() => {
                        setbBettingPhase(false)

                    }, 2000);
                }
            }, 10)

        }
        return () => {
            clearInterval(bettingInterval)
            setBettingPhaseTime("Starting...")
        }
    }, [bBettingPhase]);


    useEffect(() => {
        const temp_interval = setInterval(() => {
            setChartSwitch(false)
            sendToChart();
        }, 1)

        return () => {
            clearInterval(temp_interval)
            setChartSwitch(true)
        }
    }, [chartSwitch])

    useEffect(() => {

        setChartSwitch(true)
        setStartTime(Date.now())
        let getActiveBettorsTimer = setTimeout(() => retrieve_active_bettors_list(), 1000);
        let getBetHistory = setTimeout(() => retrieve_bet_history(), 1000);

        return () => {

            clearTimeout(getActiveBettorsTimer);
            clearTimeout(getBetHistory);
        };
    }, [])










    const manual_cashout_early = async () => {

        let data = {
            "betId": crashBetId,
            "isWoned": true
        }

        if (liveMultiplierSwitch) {

            setLoading(true);
            let res = await dispatch(getManualCashout(data));
            console.log("🚀 ~ file: index.js:851 ~ constmanual_cashout_early=  ~ res:", res)
            if (res?.status) {
                setBetActive(false);
                localStorage.removeItem('betactive')
                localStorage.removeItem("cashout")

                setUpdateRes(res);
                setUpdatebalance(res?.balance)
                setBalance(res?.balance);
                setLoading(false);
            }
            else {
                setLoading(false)
            }
        }
    }



    const auto_cashout_early = () => {


        let data = {
            "betId": crashBetId,
            "isWoned": true
        }
        autoCashoutEarly(data);
    }

    const autoCashoutEarly = async (data) => {
        setLoading(true);
        let res = await dispatch(getAutoCashout(data))

        if (res?.status === true) {
            setBetActive(false);
            localStorage.removeItem('betactive')
            localStorage.removeItem("cashout")

            setUpdateRes(res);
            setUpdatebalance(res?.balance)
            setBalance(res?.balance);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }

    const loss_update = () => {
        let data = {
            "data": crashBetId
        }
        lossUpdate(data);
    }

    const lossUpdate = async (data) => {
        // setLoading(true);
        let res = await dispatch(getlossdata(data))

        if (res?.status === true) {

            setLoading(false);
            setUpdateRes(res);
        }

        else {
            setLoading(false);
            setUpdateRes(res);
        }
    }




    const autobetnextround = () => {

        setAutobet(!autobet)

        if (stop_on_profit || stop_on_loss) {
            setStopbalance(balanceRef?.current)

        }


    }


    const retrieve = () => {
        Axios.get(API_BASE + "/retrieve", {
            withCredentials: true
        }).then(res => {
            setMultiplier(res.data)
        })
    }

    const retrieve_active_bettors_list = () => {

    };

    const retrieve_bet_history = () => {

    };

    // Functions
    const handleKeyDownBetting = (e) => {
        if (e.key === 'Enter') {
            if (bBettingPhase) {

                betFunction()
            }
            else {
                bet_next_round()
            }
        }
    }


    const bet_next_round = () => {

        if (Number(cashOutValue) <= 2) {
            setCashOutValue(2)

        }
        setbBetForNextRound(!bBetForNextRound) //
        setIsBet(!isBet)
    };


    const verifyBetAmount = (text) => {
        const validated = text.match(/^(\d*\.{0,1}\d{0,2}$)/)
        const re = /^[0-9\b]+$/;

        if (text === '' || re.test(text)) {
            setBetAmount(text)
        }
        if (text > userData?.balance) {
            setErrorMessage("Bet greater than balance")
        } else {
            setErrorMessage('')
        }
    };

    const verifyMultiplierAmount = (text) => {
        const validated = text.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if (validated) {
            setAutoPayoutMultiplier(text)
        }
    };

    var myImg = new Image();
    myImg.src = RktBlue;

    // Chart Data

    const sendToChart = () => {
        setChartData({
            labels: timeCount_xaxis.current.slice(Math.max(timeCount_xaxis.current.length - 1)),
            // labels: timeCount_xaxis.current,
            type: 'line',
            datasets: [
                {
                    data: multiplierCount.current.slice(Math.max(multiplierCount.current.length - 1)),
                    // data: multiplierCount.current,
                    backgroundColor: "rgba(75,192,192,0.2)",
                    borderColor: "rgba(153, 102, 255, 1)",
                    color: "rgba(255, 255, 255,1)",
                    // pointStyle: 'star',
                    // pointRadius: (point) => {
                    //     const pointLength = point?.chart?.data?.labels?.length - 1;
                    //     const pointsArray = [];
                    //     for (let i = 0; i <= pointLength; i++) {
                    //         if (i === pointLength) {
                    //             pointsArray.push(10);
                    //         }
                    //         else {
                    //             pointsArray.push(0);
                    //         }
                    //     }
                    //     return pointsArray;
                    // },

                    // pointHitRadius: 10,


                    // borderWidth: 3,
                    // pointStyle: [myImg],
                    lineTension: 0,
                },
            ],
        });

        setChartOptions({
            events: [],
            maintainAspectRatio: false,
            elements: {
                line: {
                    tension: 0
                },
                point: {
                    radius: 0
                }
            },
            scales: {
                y: {
                    type: 'linear',
                    display: false,
                    title: {
                        display: false,
                        text: 'value'
                    },
                    min: 1,
                    max: (liveMultiplier > 2 ? (liveMultiplier) : (2)),
                    ticks: {
                        color: "rgba(255, 255, 255,1)",
                        maxTicksLimit: 5,
                        callback: function (value, index, values) {
                            if (value % 0.5 == 0) {
                                return (parseFloat(value))?.toFixed(2)
                            }
                        }
                    },
                    grid: {
                        display: false,
                        color: 'white'
                    },
                },
                x: {
                    type: 'linear',
                    display: false,
                    title: {
                        display: false,
                        text: 'value'
                    },
                    max: (gamePhaseTimeElapsed > 2 ? (gamePhaseTimeElapsed) : (2)),
                    ticks: {
                        color: "rgba(255, 255, 255,1)",
                        maxTicksLimit: 5,
                        callback: function (value, index, values) {
                            if (gamePhaseTimeElapsed < 10) {
                                if (value % 1 == 0) return value;
                            } else {
                                if (value % 10 == 0) return value;
                            }
                        }
                    },
                    grid: {
                        display: false,
                        color: 'white'
                    },
                },
            },
            plugins: {
                legend: { display: false },
            },
            animation: {
                x: {
                    type: 'number',
                    easing: 'linear',
                    duration: 0,
                    from: 5,
                    delay: 0,
                },
                y: {
                    type: 'number',
                    easing: 'linear',
                    duration: 0,
                    from: 5,
                    delay: 0
                },
                loop: true,
            },
        }
        );
    }




    // GET CASHOUT LIMIT 

    useEffect(() => {
        getGame();
    }, []);


    const getGame = async () => {
        let data = {
            "routes": "crash"
        }
        setLoading(true);
        let res = await dispatch(getGames(data));
        setTimeout(() => {
            if (res?.status) {
                setMaxBet(res?.data?.max_bet);
                setMinBet(res?.data?.min_bet);
                setBetAmount(5);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 500);
    }

    const CashOutLimit = (type) => {
        if (type === "+") {
            let val = cashOutRef.current + 1;
            val > 100 ? setCashOutValue(cashOutRef.current) : setCashOutValue(val);
        }
        else if (type === "-") {
            let val = cashOutRef.current - 1;
            val <= 2 ? setCashOutValue(2) : setCashOutValue(val);
        }
        else {
            const { value } = type;
            setCashOutValue(value)


        }
    }


    const getBetAmount = (inputObj) => {
        const { value } = inputObj;
        if (value <= maxBet) {



            setBetAmount(Number(value)?.toFixed(2));

        }

    }


    const setShareAmount = (type) => {
        if (type === "/2") {
            let calc = +betRef.current / 2;
            if (calc > minBet) {
                setBetAmount(Number(calc)?.toFixed(2));
            }
            else {
                setBetAmount(Number(minBet)?.toFixed(2));
            }
        }
        else if (type === "2x") {
            let calc = +betRef.current * 2;
            if (calc < maxBet) {
                setBetAmount(Number(calc)?.toFixed(2));
            }
            else {
                setBetAmount(Number(maxBet)?.toFixed(2));
            }
        }
    }

    const maximumBetAmount = () => {
        Confirm.show(`${t('Confirmation')}`, `${t('Maximum bet applied, please confirm')}`,
            `${t('Yes')}`,
            `${t('No')}`,
            () => {
                setBetAmount(Number(maxBet)?.toFixed(2));
            },
            () => {

            },
            {
            },
        );
    }


    //  ===============  Bet Function  ==============

    const betFunction = async () => {

        if (Number(cashOutValue) <= 2) {
            setCashOutValue(2)

        }

        if (+balanceRef?.current <= +betAmount || +balanceRef?.current == 0) {
            Notify.failure(balanceRef.current == 0 ? `${t('Not Enough Balance')} !!!` : "Bet Amount Must be less then Balance !! ", { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (+minBet > +betAmount) {
            Notify.failure(`${t('Bet Amount Must be higher then Minimum Amount')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (+maxBet < +betAmount) {
            Notify.failure(`${t('Bet Amount Must be higher then Minimum Amount')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else {


            let data = {
                "cashout_at": Number(cashOutValue) <= 2 ? 2 : cashOutValue,
                "bet_amonut": betAmount,
                "type": mode,
                "currency": selectCurrency?.symbol,
                "loopid": "6448f9fe4c8b7d5ca6dba6bc",
            }

            localStorage.setItem("cashout", cashOutValue)
            setLoading(true);
            let res = await dispatch(betCrash(data));
            setTimeout(() => {
                if (res?.status === true) {


                    setLoading(false);

                    setCrashBetId(res?.betId);
                    localStorage.setItem("betid", res?.betId)

                    setUpdateRes(res);
                    setUpdatebalance(res?.balance?.toFixed(2))
                    setBalance(res?.balance?.toFixed(2));
                    setBetemit(true)
                    setBetActive(true);
                    localStorage.setItem("betactive", true)
                    setIsBet(true);
                    setAutobetamt(+res?.balance?.toFixed(2) + +betAmount)


                    if (no_of_bets) {

                        setNo_of_bets(no_of_bets == 0 ? 0 : no_of_bets - 1)
                    }
                }
                else {
                    setLoading(false);
                }
            }, 500);
        }
    }


    //  ---------------  Error Function  ----------- 


    const errorFunction = () => {
        if (userToken === null || userToken === undefined || userToken === "") {
            setModal(!modal);
        }
        else {
            Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
    }

    const getMaxBetAmount = (inputObj) => {
        const { value } = inputObj;
        if (value <= maxBet) {
            setMaxBetAmount(value);
            return true;
        }
    }




    useEffect(() => {
        if (updatebalance && betAmount && onWinAmount) {
            if (+updatebalance >= +autobetamt) {
                if (+maxBetAmount <= Number(+betAmount + (+betAmount / 100 * +onWinAmount))?.toFixed(2)) {
                    setBetAmount(Number(maxBetAmount)?.toFixed(2))
                }
                else {
                    setBetAmount(Number(+betAmount + (+betAmount / 100 * +onWinAmount))?.toFixed(2))
                }
            }
        }
    }, [updatebalance, autobetamt, onWinAmount]);


    useEffect(() => {
        if (betAmount && onLossAmount && updatebalance) {
            if (!betActive) {
                if (+updatebalance <= +autobetamt) {
                    if (+maxBetAmount <= Number(+betAmount + (+betAmount / 100 * +onLossAmount))?.toFixed(2)) {
                        setBetAmount(Number(maxBetAmount)?.toFixed(2))
                    }
                    else {
                        setBetAmount(Number(+betAmount + (+betAmount / 100 * +onLossAmount))?.toFixed(2))
                    }
                }
            }
        }
    }, [crashBetId, autobetamt, onLossAmount, updatebalance]);


    //  Single Bet Details

    const toggleBetDetails = () => {
        setBetModal(!betModal);
    };

    useEffect(() => {
        document.body.classList.remove("SideMenuOpen");
        setClassIsActive(false);
    }, []);


    useEffect(() => {
        if (startRocket === false) {
            document.querySelectorAll('.rckBls').forEach(e => e.classList.add('show'));
            document.querySelectorAll('.rctSet').forEach(e => {
                e.classList.add('rctPuse');
                e.pauseAnimations();
            });
            // if (liveMultiplier === "CONNECTING..." || liveMultiplier === "Starting..." && startRocket === false) {
            setTimeout(() => {
                setIsFreeze(false);
                idleGif();
            }, 2500);
        }
        // }
    }, [startRocket]);

    useEffect(() => {
        if (isFreeze === false) {
            document.querySelectorAll('.rctSet').forEach(e => e.unpauseAnimations());
        }
    }, [isFreeze]);

    useEffect(() => {
        if (liveMultiplier && startRocket) {
            moveGif();
        }
        else if (liveMultiplier === "CONNECTING..." || liveMultiplier === "Starting..." && startRocket === false) {
            setIsFreeze(false);
            idleGif();
        }
    }, [startRocket]);


    const idleGif = () => {
        document.querySelectorAll('.idle_rocket').forEach(e => e.beginElement());
        document.querySelectorAll('.rctSet').forEach(e => e.classList.remove('rctMoving'));
        document.querySelectorAll('.rckBls').forEach(e => e.classList.remove('show'));

        document.querySelectorAll('.rctSet').forEach(e => {
            setTimeout(() => {
                e.classList.remove('rctPuse');
            }, 100)
            e.classList.add('rctReady');
        });

    }

    const moveGif = () => {
        setIsFreeze(true);
        document.querySelectorAll('.moving_rocket').forEach(e => e.beginElement());
        //document.querySelector('.rctSet').classList.add('rctMoving');
        document.querySelectorAll('.rctSet').forEach(e => {
            e.classList.remove('rctReady');
            e.classList.add('rctMoving');
        });
    }

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);


        return {
            total, hours, minutes, seconds
        };
    }

    const startTimer = (e) => {
        let { total, hours, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                // (hours > 9 ? hours : '0' + hours) + ':' +
                // (minutes > 9 ? minutes : '0' + minutes) + ':'
                // + 
                (seconds > 9 ? seconds : seconds)
            )
        }
    }

    const clearTimer = (e) => {
        // setTimer('30');
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 7);
        return deadline;
    }

    useEffect(() => {
        clearTimer(getDeadTime());
    }, [startCount && startCount]);

    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">

                            <div className="transactionpage-maincnt page-centercnt_nd_bg crashpage-maincnt">
                                <section className="mines_sec_1">
                                    <div class="crashpage-gridmain my-md-5">
                                        <div className="rocketArea">
                                            <div class="rcktBtnsPt">
                                                <div class="rcktBtns">
                                                    {/* <button class="rcktBtn gr stk">
                                                        <img src={chartImg} alt="chart-arrow" class="img-fluid" />
                                                    </button> */}

                                                    {removeDuplicateByNext(crash_history_data)?.map((element, index) => {

                                                        return (
                                                            element >= 10 ? (
                                                                <button key={index} class="rcktBtn red">
                                                                    {element?.toFixed(2) + " x"}
                                                                </button>
                                                            ) : (
                                                                element > 2 ? (
                                                                    <button key={index} class="rcktBtn gr">
                                                                        {element?.toFixed(2) + " x"}
                                                                    </button>
                                                                ) : (
                                                                    <button key={index} class="rcktBtn">
                                                                        {element?.toFixed(2) + " x"}
                                                                    </button>
                                                                )
                                                            )
                                                        )
                                                    })}
                                                </div>
                                            </div>


                                            <div class="rocket-animation">
                                                <div class="rocketimg-box" >

                                                    <div class="RctStar" style={{ animation: liveMultiplier && liveMultiplier && startRocket && startRocket ? "star-movement 2.5s linear 0s infinite" : "" }}>
                                                        {/* <img src={star} alt="" class="img-fluid "  /> */}
                                                    </div>

                                                    <div class="rcktNwSts">
                                                        <span>Network Status</span>
                                                        <span class={isNetwork ? "cr" : "cf"}></span>
                                                    </div>

                                                    <button onClick={() => setBoardIsActive(!boardISActive)} className="btn shwBts d-md-none">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="44" height="44" viewBox="0 0 24 24" stroke-width="1" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                            <path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                                            <path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
                                                            <path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                                            <path d="M17 10h2a2 2 0 0 1 2 2v1" />
                                                            <path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                                            <path d="M3 13v-1a2 2 0 0 1 2 -2h2" />
                                                        </svg>
                                                    </button>

                                                    <div class={boardISActive ? "rcktBts shwBtsLs" : "rcktBts"}>
                                                        <div class="rcktBtsLs">
                                                            {liveBettingTable?.length > 0 ? liveBettingTable?.map((element, index) => {
                                                                return (
                                                                    <div class="rcktBtsR" key={index}>
                                                                        <span class="rBtsUNm">{element?.the_username}</span>
                                                                        <span class="rBtsPwr">{element?.b_bet_live ? "Betting..." : element?.cashout_multiplier}</span>
                                                                        <span class="rBtsPrc">
                                                                            {element?.profit_status ? element?.profit ? element?.profit : element?.bet_amonut * element?.cashout_multiplier : element?.bet_amonut}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            })
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    </div>



                                                    <div class="spaceimg d-none">
                                                        <img src={space} alt="" class="img-fluid RctSpac1" style={{ animation: liveMultiplier && liveMultiplier && startRocket && startRocket ? "movementspace1 15s linear 1s infinite" : "" }} />
                                                    </div>

                                                    <div className="strnImg" style={liveMultiplier && liveMultiplier && startRocket && startRocket ? { animation: "saturnMove 10s linear 0s 1 forwards" } : { transform: "scale(0.3) translate(-100%,-600%)", animation: "saturnMove2 3s linear 0s 1 forwards" }}>
                                                        <img src={saturn} alt="saturn" />
                                                    </div>



                                                    {/* <svg width="1090" height="654" viewBox="0 0 1090 654" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className={startRocket && startRocket ? "rctSet rctMoving" : startRocket === false ? "rctSet rctReady" : "rctSet rctMoving rctPuse"}> */}
                                                    <svg width="1090" height="654" viewBox="0 0 1090 654" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="rctSet">
                                                        <g filter="url(#rctPathGlow)">
                                                            <path d="M179 594C306 594 1040 594 1040 60" stroke="url(#rctPathGr1)" stroke-width="12" class="rocket-stroke" />
                                                        </g>
                                                        <path d="M179 594C306 594 1040 594 1040 60" stroke="url(#rctPathGr2)" stroke-width="5" id="rocetPath" class="rocket-stroke" />

                                                        <mask id="rckGpMsk" xmlns="http://www.w3.org/2000/svg" maskUnits="userSpaceOnUse" x="0" y="0" width="1090" height="654" style={{ maskType: "alpha" }}>
                                                            <path xmlns="http://www.w3.org/2000/svg" d="M1090 0H70L0 327V654H1090V0Z" fill="#E6E6E6" />
                                                        </mask>

                                                        <g xmlns="http://www.w3.org/2000/svg" mask="url(#rckGpMsk)">
                                                            <g className="no-gif">
                                                                <image width="200" height="200" xlinkHref={fireImg} class="rcktFire" transform="translate(33 -98) rotate(95 0 1)"></image>
                                                                <image width="200" height="200" xlinkHref={smookeImage} class="rcktSmoke" transform="translate(33 -98) rotate(95 0 1)"></image>
                                                                <image width="100" xlinkHref={racoonS} class="rckt" transform="translate(-88 -52)" />
                                                                <image width="100" xlinkHref={racoonParachute} class="rckPrch" />
                                                                <image width="100" height="100" xlinkHref={Rocketblast} className="rckBls" />
                                                                <animateMotion class="idle_rocket" dur="0s" begin="0s" repeatCount="0" fill="freeze" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                    <mpath href="#rocetPath"></mpath>
                                                                </animateMotion>
                                                                {
                                                                    rocketStatus && rocketStatus ?
                                                                        <animateMotion className="moving_rocket" dur="2s" begin="0s" repeatCount="0" fill={isFreeze && isFreeze ? "freeze" : null} rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                            <mpath href="#rocetPath"></mpath>
                                                                        </animateMotion>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    isFreeze && isFreeze === false ?
                                                                        <animateMotion className="idle_rocket_2" dur="0s" begin="0s" repeatCount="0" fill="freeze" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                            <mpath href="#rocetPath"></mpath>
                                                                        </animateMotion>
                                                                        :
                                                                        null
                                                                }
                                                            </g>
                                                        </g>

                                                        <defs>
                                                            <filter id="rctPathGlow" x="170" y="51" width="885" height="558" filterUnits="userSpaceOnUse"
                                                                color-interpolation-filters="sRGB">
                                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                                                <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_445_14049" />
                                                            </filter>
                                                            <linearGradient id="rctPathGr1" x1="892.003" y1="197.783" x2="420.821" y2="472.582"
                                                                gradientUnits="userSpaceOnUse">
                                                                <stop stop-color="#FF0A57" />
                                                                <stop offset="1" stop-color="#641AFF" stop-opacity="0.03" />
                                                            </linearGradient>
                                                            <linearGradient id="rctPathGr2" x1="846.334" y1="176.148" x2="177.947" y2="400.344"
                                                                gradientUnits="userSpaceOnUse">
                                                                <stop stop-color="#FF0A57" />
                                                                <stop offset="1" stop-color="#FD0957" stop-opacity="0" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>


                                                    <svg width="350" height="342" viewBox="0 0 350 342" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className={startRocket ? "rctSet rctMoving rctSetMbl" : "rctSet rctMoving rctSetMbl rctPuse"}>
                                                        <g filter="url(#rctPathGlow_mb)">
                                                            <path d="M82.5 312.5C96 312.5 319 312.5 319 20" stroke="url(#rctPathGr1_mb)" stroke-width="4" class="rocket-stroke mb" />
                                                        </g>
                                                        <path d="M82.5 312.5C96 312.5 319 312.5 319 20" stroke="url(#rctPathGr2_mb)" stroke-width="2.5" id="rocetPath_Mb" class="rocket-stroke mb" />
                                                        <g>
                                                            <image width="100" height="100" xlinkHref={fireImg} class="rcktFire" transform="translate(33 -98) rotate(95 0 1)"></image>
                                                            <image width="100" height="100" xlinkHref={smookeImage} class="rcktSmoke" transform="translate(33 -98) rotate(95 0 1)"></image>
                                                            <image width="80" xlinkHref={racoonS} class="rckt" transform="translate(-88 -52)" />
                                                            <image width="80" xlinkHref={racoonParachute} class="rckPrch" />
                                                            <image width="80" height="80" xlinkHref={Rocketblast} className="rckBls" />
                                                            <animateMotion class="idle_rocket" dur="0s" begin="0s" repeatCount="0" fill="freeze" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                <mpath href="#rocetPath_Mb"></mpath>
                                                            </animateMotion>
                                                            {
                                                                rocketStatus && rocketStatus ?
                                                                    <animateMotion className="moving_rocket" dur="2s" begin="0s" repeatCount="0" fill={isFreeze && isFreeze ? "freeze" : null} rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                        <mpath href="#rocetPath_Mb"></mpath>
                                                                    </animateMotion>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                isFreeze && isFreeze === false ?
                                                                    <animateMotion className="idle_rocket_2" dur="0s" begin="0s" repeatCount="0" fill="freeze" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="linear" restart="always">
                                                                        <mpath href="#rocetPath_Mb"></mpath>
                                                                    </animateMotion>
                                                                    :
                                                                    null
                                                            }
                                                        </g>
                                                        <defs>
                                                            <filter id="rctPathGlow_mb" x="73.5" y="11" width="258.5" height="314.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                                                <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_466_13298" />
                                                            </filter>
                                                            <linearGradient id="rctPathGr1_mb" x1="278.348" y1="75.818" x2="116.587" y2="119.296" gradientUnits="userSpaceOnUse">
                                                                <stop stop-color="#FF0A57" />
                                                                <stop offset="1" stop-color="#641AFF" stop-opacity="0.03" />
                                                            </linearGradient>
                                                            <linearGradient id="rctPathGr2_mb" x1="265.804" y1="83.6206" x2="67.1742" y2="117.031" gradientUnits="userSpaceOnUse">
                                                                <stop stop-color="#FF0A57" />
                                                                <stop offset="1" stop-color="#FD0957" stop-opacity="0" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>


                                                </div>


                                                <div className="chart-txt">
                                                    {(() => {
                                                        if (bBettingPhase) {
                                                            return <h3 className="points_Label">{('Starts in  ' + timer)}</h3>
                                                        } else {
                                                            return <h3 className={`${!liveMultiplierSwitch && liveMultiplier !== 'Starting...' && liveMultiplier !== 'CONNECTING...' ? ("multipler_crash_value_message") : ("points_Label")}`}>{liveMultiplier !== "Starting..." ? (liveMultiplier + 'x') : ('Starts in  ' + timer)}</h3>
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                            <div className="row rip_rowj">
                                                <div className="col-12 rip_col">
                                                    <div className="cashout-totbox" >
                                                        <div className="hji_tr mt-3 d-flex align-items-center justify-content-between" style={{ cursor: isBet ? "not-allowed" : "pointer" }} >
                                                            <div class="MinMaxCnt">
                                                                <button className="btn mb-1" disabled={isBet} onClick={() => setBetAmount(Number(minBet)?.toFixed(2))}>{t("Minimum")}</button>
                                                                <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={maximumBetAmount}>{t("Maximum")}</button>
                                                            </div>
                                                            <div className="d-flex align-items-center pg_ki">
                                                                <div class="CurncyIcon mr-2">
                                                                    {/* <img src={dim} alt="" /> */}
                                                                    <b>R$</b>
                                                                </div>
                                                                <div className="form-group mb-0">
                                                                    <NumericFormat class="form-control" onChange={(e) => setBetAmount(Number(e.target.value))} value={Number(betAmount)} allowNegative={false} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <button className="btn mb-1" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("/2")}>1/2</button>
                                                                <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("2x")}>2X</button>
                                                            </div>

                                                        </div>


                                                        <div className="cashoutbet-btn mt-2 mt-md-3">
                                                            <div className="hji_tr_2">
                                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                                    <button onClick={() => CashOutLimit("+")} className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet}><svg width="16" height="16" viewBox="0 0 16 16"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_614_24757)">
                                                                            <path d="M8 3.33337V12.6667" stroke="white"
                                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M3.33301 8H12.6663" stroke="#80899F"
                                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_614_24757">
                                                                                <rect width="16" height="16" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    </button>
                                                                    <div>
                                                                        <div className="form-group mb-0">
                                                                            <NumericFormat class="form-control" onChange={(e) => setCashOutValue(e.target.value)} value={Number(cashOutValue)} allowNegative={false} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                        </div>
                                                                    </div>
                                                                    <button className="btn" onClick={() => CashOutLimit("-")} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet}><svg width="16" height="16" viewBox="0 0 16 16"
                                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_614_24766)">
                                                                            <path d="M3.33301 8H12.6663" stroke="#80899F"
                                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_614_24766">
                                                                                <rect width="16" height="16" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    </button>
                                                                </div>
                                                                <div>
                                                                    <h2 className="mb-0">{t("Cashout At")}</h2>
                                                                </div>
                                                            </div>
                                                            <div className="hji_tr_3 gmBtBtn">
                                                                {mode == "manual" ? (bBettingPhase && !betActive ? (<button class="btn w-100 grBtn" onClick={userToken ? betFunction : errorFunction}>{t("Bet")}</button>) : (
                                                                    <>
                                                                        {betActive ? (<div>
                                                                            <button class="btn w-100 grBtn" onClick={manual_cashout_early} disabled={betActive && liveMultiplier > 1 ? false : true}> {(betActive && liveMultiplier > 1) ? (<span>{t("Cashout At")} {(liveMultiplier * betAmount).toFixed(2)}</span>) : (t("Starting..."))}</button>
                                                                        </div>) : (<div>
                                                                            <button class="btn w-100 grBtn" onClick={userToken ? bet_next_round : errorFunction}>{bBetForNextRound ? (t("Cancel Bet")) : (t("Bet"))}
                                                                                <br />
                                                                                {(t("Next Round"))}
                                                                            </button>
                                                                        </div>)}
                                                                    </>
                                                                )) : (<>

                                                                    {bBettingPhase && !betActive ? (<button class="btn w-100 grBtn" onClick={async () => {
                                                                        if (userToken) {
                                                                            await autobetnextround();
                                                                            await betFunction()
                                                                        }
                                                                        else {
                                                                            errorFunction();
                                                                        }
                                                                    }}>{autobet ? (t("STOP")) : (t("START"))}</button>) : (

                                                                        betActive ? (

                                                                            <button class="btn w-100 grBtn" onClick={betActive ? manual_cashout_early : autobetnextround} disabled={betActive && liveMultiplier > 1 ? false : true}>{(betActive && liveMultiplier > 1) ? (<span>{t("Cashout At")} {(liveMultiplier * betAmount).toFixed(2)}</span>) : (autobet ? (t("STOP")) : (t("START")))}</button>
                                                                        ) : (
                                                                            <button class="btn w-100 grBtn" onClick={userToken ? autobetnextround : errorFunction}>{autobet ? (t("STOP")) : (t("START"))} </button>
                                                                        )
                                                                    )}
                                                                </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </section>
                                <section className="mines_sec_2">
                                    <div className="m-0">
                                        <div className=" d-flex justify-content-center" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet}>
                                            <Nav tabs className="ma_ato_tab">
                                                <NavItem style={{ cursor: isBet ? "not-allowed" : "pointer" }}>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === '1' })}
                                                        disabled={isBet}
                                                        onClick={() => {
                                                            toggle('1');
                                                            setMode("manual");
                                                        }}
                                                    >
                                                        {t("Manual")}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem style={{ cursor: isBet ? "not-allowed" : "pointer" }}>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === '2' })}
                                                        disabled={isBet}
                                                        onClick={() => {
                                                            toggle('2');
                                                            setMode("auto");
                                                        }}
                                                    >
                                                        {t("Auto")}
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </div>
                                        <div className="pt-2">
                                            <TabContent activeTab={activeTab}>
                                                <TabPane tabId="1">
                                                    <div className="ahm_sec m-0">
                                                        <div className=" d-md-flex align-items-center justify-content-between flex-wrap">
                                                            <Nav tabs className="ahm_tab_hd my-2">
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '1' })}
                                                                        onClick={() => { toggleInner('1'); }}
                                                                    >
                                                                        {t("All Bets")}
                                                                    </NavLink>
                                                                </NavItem>

                                                                {userToken ? (
                                                                    <NavItem>
                                                                        <NavLink
                                                                            className={classnames({ active: activeTab1 === '2' })}
                                                                            onClick={() => { toggleInner('2'); }}
                                                                        >
                                                                            {t("My Bets")}
                                                                        </NavLink>
                                                                    </NavItem>
                                                                ) : null}
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '3' })}
                                                                        onClick={() => { toggleInner('3'); }}
                                                                    >
                                                                        {t("High Rollers")}
                                                                    </NavLink>
                                                                </NavItem>

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '4' })}
                                                                        onClick={() => { toggleInner('4'); }}
                                                                    >
                                                                        {t("Rare Wins")}
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                            {/* <div className="ahm-sel-bx d-flex align-items-center my-md-2 mt-3">
                                                                <h2 className="mr-2 mb-0">{t("Show")}</h2>
                                                                <div className="form-group mb-0">
                                                                    <select className="form-control"
                                                                        id="exampleFormControlSelect1" onChange={(event) => gameBetHistory(event.target.value)} >
                                                                        {
                                                                            betCounts?.map((temp, index) =>
                                                                                <option key={index} value={temp?.value}>{temp?.pageLimit}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="pt-2">
                                                            <TabContent activeTab={activeTab1}>
                                                                <TabPane tabId="1">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    gamehist?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {gamehist?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">

                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }}
                                                                                                                        src={elements?.user_id?.profile_picture} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>
                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}>{elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>
                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                gamehist?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="2">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    onegamehistory?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {onegamehistory?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>
                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                onegamehistory?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="3">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")} </th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    crashHighRollers?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {crashHighRollers?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                crashHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="4">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")} </th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    historydata?.data?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {historydata?.data?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                crashHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                            </TabContent>
                                                        </div>
                                                    </div>
                                                </TabPane>
                                                <TabPane tabId="2">
                                                    <div class="auto-mem_1">
                                                        <div class="row">
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Number Of Bets")}</h2>
                                                                <div class="input-group mb-3">
                                                                    <NumericFormat class="form-control" value={no_of_bets} allowNegative={false} onChange={(e) => {
                                                                        setExistbet(true)
                                                                        setNo_of_bets(e.target.value)
                                                                    }} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text"><svg width="18"
                                                                            height="8" viewBox="0 0 18 8" fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="M8.99974 4.00008C8.54246 4.88773 7.92939 5.68598 7.18974 6.35675C6.7236 6.82303 6.12966 7.14059 5.48303 7.26929C4.8364 7.39799 4.16612 7.33204 3.55698 7.07978C2.94783 6.82752 2.42718 6.40027 2.06086 5.85209C1.69455 5.3039 1.49902 4.6594 1.49902 4.00008C1.49902 3.34077 1.69455 2.69626 2.06086 2.14808C2.42718 1.59989 2.94783 1.17265 3.55698 0.920388C4.16612 0.668126 4.8364 0.602173 5.48303 0.730872C6.12966 0.859571 6.7236 1.17714 7.18974 1.64342C7.92939 2.31419 8.54246 3.11243 8.99974 4.00008ZM8.99974 4.00008C9.45701 3.11243 10.0701 2.31419 10.8097 1.64342C11.2759 1.17714 11.8698 0.859571 12.5164 0.730872C13.1631 0.602173 13.8333 0.668126 14.4425 0.920388C15.0516 1.17265 15.5723 1.59989 15.9386 2.14808C16.3049 2.69626 16.5004 3.34077 16.5004 4.00008C16.5004 4.6594 16.3049 5.3039 15.9386 5.85209C15.5723 6.40027 15.0516 6.82752 14.4425 7.07978C13.8333 7.33204 13.1631 7.39799 12.5164 7.26929C11.8698 7.14059 11.2759 6.82303 10.8097 6.35675C10.0701 5.68598 9.45701 4.88773 8.99974 4.00008Z"
                                                                                stroke="#48567B" stroke-width="1.25"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round" />
                                                                        </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Stop on profit")}</h2>
                                                                <div class="form-group ">
                                                                    <NumericFormat class="form-control" value={stop_on_profit} allowNegative={false} placeholder="0" onChange={(e) => {
                                                                        setExistprofitstop(true)


                                                                        setStop_on_profit(e.target.value)
                                                                    }} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Stop on loss")}</h2>
                                                                <div class="form-group ">
                                                                    <NumericFormat class="form-control" value={stop_on_loss} allowNegative={false} placeholder="0" onChange={(e) => {
                                                                        setExistlossstop(true)


                                                                        setStop_on_loss(e.target.value)
                                                                    }} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Max bet amount")}</h2>
                                                                <div class="input-group mb-3">
                                                                    <NumericFormat class="form-control" value={maxBetAmount} allowNegative={false} placeholder="0" onChange={(e) => setMaxBetAmount(e.target.value)} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text"
                                                                            id="basic-addon2"><svg width="18" height="8"
                                                                                viewBox="0 0 18 8" fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg">
                                                                                <path
                                                                                    d="M8.99974 4.00008C8.54246 4.88773 7.92939 5.68598 7.18974 6.35675C6.7236 6.82303 6.12966 7.14059 5.48303 7.26929C4.8364 7.39799 4.16612 7.33204 3.55698 7.07978C2.94783 6.82752 2.42718 6.40027 2.06086 5.85209C1.69455 5.3039 1.49902 4.6594 1.49902 4.00008C1.49902 3.34077 1.69455 2.69626 2.06086 2.14808C2.42718 1.59989 2.94783 1.17265 3.55698 0.920388C4.16612 0.668126 4.8364 0.602173 5.48303 0.730872C6.12966 0.859571 6.7236 1.17714 7.18974 1.64342C7.92939 2.31419 8.54246 3.11243 8.99974 4.00008ZM8.99974 4.00008C9.45701 3.11243 10.0701 2.31419 10.8097 1.64342C11.2759 1.17714 11.8698 0.859571 12.5164 0.730872C13.1631 0.602173 13.8333 0.668126 14.4425 0.920388C15.0516 1.17265 15.5723 1.59989 15.9386 2.14808C16.3049 2.69626 16.5004 3.34077 16.5004 4.00008C16.5004 4.6594 16.3049 5.3039 15.9386 5.85209C15.5723 6.40027 15.0516 6.82752 14.4425 7.07978C13.8333 7.33204 13.1631 7.39799 12.5164 7.26929C11.8698 7.14059 11.2759 6.82303 10.8097 6.35675C10.0701 5.68598 9.45701 4.88773 8.99974 4.00008Z"
                                                                                    stroke="#48567B" stroke-width="1.25"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round" />
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("On win")}</h2>
                                                                <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
                                                                    <div class="mr-3">
                                                                        <div class="swi_nd mb-3">
                                                                            <div class="d-flex align-items-center">
                                                                                <label class="switch mb-0">
                                                                                    <input type="checkbox" checked={onWinIsChecked} onChange={() => { setOnWinIsChecked(!onWinIsChecked); setOnWinAmount() }} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                                    <span class="slider"></span>
                                                                                </label>
                                                                                <div>
                                                                                    <h2 class="mb-0 active">{t("Reset")}</h2>
                                                                                    <h2 class="mb-0">{t("Increase")}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div class="input-group mb-3">
                                                                            <NumericFormat class="form-control" allowNegative={false} placeholder="0" value={onWinAmount} onFocus={() => setOnWinIsChecked(true)} onChange={(e) => setOnWinAmount(e.target.value)} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                            <div class="input-group-append">
                                                                                <span class="input-group-text" id="basic-addon2">%
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("On loss")}</h2>
                                                                <div class="d-flex flex-md-nowrap flex-wrap align-items-center">
                                                                    <div class="mr-3">
                                                                        <div class="swi_nd mb-3">
                                                                            <div class="d-flex align-items-center">
                                                                                <label class="switch mb-0">
                                                                                    <input type="checkbox" checked={onLossIsChecked} onChange={() => { setOnLossIsChecked(!onLossIsChecked); setOnLossAmount("") }} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                                    <span class="slider"></span>
                                                                                </label>
                                                                                <div>
                                                                                    <h2 class="mb-0 ">{t("Reset")}</h2>
                                                                                    <h2 class="mb-0 active">{t("Increase")}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div class="input-group mb-3">
                                                                            <NumericFormat class="form-control" value={onLossAmount} allowNegative={false} placeholder="0" onFocus={() => setOnLossIsChecked(true)} onChange={(e) => setOnLossAmount(e.target.value)} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} />
                                                                            <div class="input-group-append">
                                                                                <span class="input-group-text" id="basic-addon2">%
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Crash Game History in Auto Mode  */}

                                                    <div className="ahm_sec m-0">
                                                        <div className=" d-md-flex align-items-center justify-content-between flex-wrap">
                                                            <Nav tabs className="ahm_tab_hd my-2">
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '1' })}
                                                                        onClick={() => { toggleInner('1'); }}
                                                                    >
                                                                        {t("All Bets")}
                                                                    </NavLink>
                                                                </NavItem>
                                                                {userToken ? (
                                                                    <NavItem>
                                                                        <NavLink
                                                                            className={classnames({ active: activeTab1 === '2' })}
                                                                            onClick={() => { toggleInner('2'); }}
                                                                        >
                                                                            {t("My Bets")}
                                                                        </NavLink>
                                                                    </NavItem>
                                                                ) : null}
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '3' })}
                                                                        onClick={() => { toggleInner('3'); }}
                                                                    >
                                                                        {t("High Rollers")}
                                                                    </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '4' })}
                                                                        onClick={() => { toggleInner('4'); }}
                                                                    >
                                                                        {t("Rare Wins")}
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>


                                                            {/* <div className="ahm-sel-bx d-flex align-items-center my-md-2 mt-3">
                                                                <h2 className="mr-2 mb-0">{t("Show")}</h2>
                                                                <div className="form-group mb-0">
                                                                    <select className="form-control"
                                                                        id="exampleFormControlSelect1" onChange={(event) => gameBetHistory(event.target.value)} >
                                                                        {
                                                                            betCounts?.map((temp, index) =>
                                                                                <option key={index} value={temp?.value}>{temp?.pageLimit}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="pt-2">
                                                            <TabContent activeTab={activeTab1}>
                                                                <TabPane tabId="1">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    gamehist?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {gamehist?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">

                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }}
                                                                                                                        src={elements?.user_id?.profile_picture} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>
                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}>{elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>
                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                gamehist?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="2">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")} </th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    onegamehistory?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {onegamehistory?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>

                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>
                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                onegamehistory?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="3">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")} </th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    crashHighRollers?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {crashHighRollers?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            {/* <td class="ash_color"><img style={{ height: "25px", width: "25px" }} src={elements?.gameId?.icon} />{elements?.game_name}</td>
                                                                                                            <td class="ash_color">{helper?.formatDated1(elements?.updated_at)}</td> */}
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>

                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>
                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                crashHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="4">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")} </th>
                                                                                        <th>{t("Bet Amount")} </th>
                                                                                        <th>{t("Multiplier")} </th>
                                                                                        <th>{t("Payout")} </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    historydata?.data?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {historydata?.data?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>

                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>

                                                                                                            <td>{elements?.betAmonut?.toFixed(2)}</td>                                                                                                            <td><button class={elements?.isWoned !== "Won" ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(2)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                crashHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                            </TabContent>
                                                        </div>
                                                    </div>


                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div >
            </div >

            {/*  Bet Details  Modal */}

            <Modal Modal
                isOpen={betModal}
                toggle={toggleBetDetails}
                className="minesmodal-popup"
                autoFocus={false}
                centered
            >
                <ModalBody className="p-0">
                    <div class="minesmodal-content">
                        <div class="row">

                            <div className="text-right">
                                <Link to="#" onClick={toggleBetDetails}>
                                    <img src={circle} alt="" />
                                </Link>
                            </div>

                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        <div class="mines-detbox"><img src={betDetails?.gameId?.gameIcon} alt="Image Not Found" class="img-fluid" /></div>
                                    </div>
                                    <div class="col-md-6 mt-3 mt-md-0">
                                        <div class="mines-detbox d-flex flex-column justify-content-center">
                                            <h5>{t('Player')}: <span>{betDetails?.user_id?.username}</span></h5>
                                            <h5 class="my-2">{t('Date & Time')}: <span>{betDetails?.created_at}</span></h5>
                                            <h5>{t('Bet ID')}: <span>{betDetails?.gameCode}</span></h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-7 col-md-4 mx-auto">
                                        <div class="mines-detmain">
                                            <p>{t('Bet')}</p>
                                            <h5>{betDetails?.betAmonut}</h5>
                                        </div>
                                    </div>
                                    <div class="col-sm-7 col-md-4 my-3 my-md-0 mx-auto">
                                        <div class="mines-detmain">
                                            <p>{t('Multiplier')}</p>
                                            <h5>{betDetails?.multipliers}</h5>
                                        </div>
                                    </div>
                                    <div class="col-sm-7 col-md-4 mx-auto">
                                        <div class="mines-detmain">
                                            <p>{t('Payout')}</p>
                                            <h5>{betDetails?.payout}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </Fragment >
    );

}

export default Crash;